import { ClockCircleOutlined, FileImageOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import dayjs from 'dayjs';
import type { CSSProperties, ReactNode } from 'react';

import { BlogPostStatus } from '../../api/blog';
import type { BlogPostSummary } from '../../api/blog';
import { BrandColors } from '../../theme/brand';

/** Màu của từng tình trạng bài — dùng chung cho nhãn và dải số liệu. */
export const blogStatusColors = {
  draft: BrandColors.inkMuted,
  published: BrandColors.green,
  scheduled: BrandColors.gold,
} as const;

/**
 * Nhãn tình trạng của một bài: Nháp, Đã đăng, hoặc Hẹn giờ — bài đã đăng mà ngày đăng còn ở tương lai,
 * website chưa thấy.
 */
export function postStatusTag(post: Pick<BlogPostSummary, 'status' | 'isScheduled'>): ReactNode {
  if (post.status === BlogPostStatus.Draft) {
    return (
      <Tag bordered={false} style={{ marginInlineEnd: 0 }}>
        Nháp
      </Tag>
    );
  }

  if (post.isScheduled) {
    return (
      <Tag bordered={false} color="warning" icon={<ClockCircleOutlined />} style={{ marginInlineEnd: 0 }}>
        Hẹn giờ
      </Tag>
    );
  }

  return (
    <Tag bordered={false} color="success" style={{ marginInlineEnd: 0 }}>
      Đã đăng
    </Tag>
  );
}

/** Ngày giờ dạng 27/10/2026 09:30, hoặc gạch ngang khi trống. */
export function formatDateTime(value: string | null): string {
  return value === null ? '—' : dayjs(value).format('DD/MM/YYYY HH:mm');
}

/** Ảnh bìa thu nhỏ khung 16:9, hoặc ô giữ chỗ khi bài chưa có ảnh bìa. */
export function CoverThumbnail(props: { readonly url: string | null; readonly width: number }): ReactNode {
  const frame: CSSProperties = {
    width: props.width,
    aspectRatio: '16 / 9',
    borderRadius: 6,
    overflow: 'hidden',
    background: BrandColors.surfaceSubtle,
    flexShrink: 0,
  };

  if (props.url === null) {
    return (
      <div
        style={{
          ...frame,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: BrandColors.inkMuted,
          fontSize: 20,
        }}
      >
        <FileImageOutlined />
      </div>
    );
  }

  return (
    <div style={frame}>
      <img
        src={props.url}
        alt="Ảnh bìa"
        loading="lazy"
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    </div>
  );
}
